import { Form as BootstrapForm } from "react-bootstrap";
import "./InputForm.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

type InputFormType = {
  name: string;
  ariaLabel?: string;
  size: "sm" | "lg";
  onChange: (value: string, name: string) => void;
  labelText: string;
  controlId: string;
  defaultValue?: string;
  required?: boolean;
  inLineLabel?: boolean;
  textArea?: boolean;
  switchCase?: boolean;
};

export const InputForm = ({
  name,
  ariaLabel,
  size,
  onChange,
  labelText,
  controlId,
  defaultValue,
  required = false,
  inLineLabel = false,
  textArea = false,
}: InputFormType) => {
  return (
    <BootstrapForm.Group as={inLineLabel ? Row : Col} controlId={controlId}>
      <BootstrapForm.Label column sm={inLineLabel && 3}>
        {labelText}
        {required && <span className="required-label">*</span>}
      </BootstrapForm.Label>
      <Col sm={inLineLabel && 9}>
        {textArea ? (
          <BootstrapForm.Control
            type="text"
            size={size}
            aria-label={ariaLabel}
            defaultValue={defaultValue}
            name={name}
            onChange={(e) => onChange(e.target.value, e.target.name)}
            className={inLineLabel && "sm-10"}
            as="textarea"
          />
        ) : (
          <BootstrapForm.Control
            type="text"
            size={size}
            aria-label={ariaLabel}
            defaultValue={defaultValue}
            name={name}
            onChange={(e) => onChange(e.target.value, e.target.name)}
            className={inLineLabel && "sm-10"}
          />
        )}
      </Col>
    </BootstrapForm.Group>
  );
};
